/**
 * @fileOverview Funnel Chart
 */
import { generateCategoricalChart } from './generateCategoricalChart';
import { Funnel } from '../numberAxis/Funnel';
export var FunnelChart = generateCategoricalChart({
  chartName: 'FunnelChart',
  GraphicalChild: Funnel,
  validateTooltipEventTypes: ['item'],
  defaultTooltipEventType: 'item',
  axisComponents: [],
  defaultProps: {
    layout: 'centric'
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/recharts/es6/chart/FunnelChart.js
// module id = ./node_modules/recharts/es6/chart/FunnelChart.js
// module chunks = 1